import {
  IGeocodedForSearchResponseItemDetailSchema,
} from '@cian/api-models/monolith-csharp/api/geo/geocoded-for-search';

export const getDisplayName = (
  lastListItem: IGeocodedForSearchResponseItemDetailSchema | null,
  baseName: string,
) => {
  return (lastListItem && lastListItem.fullName) ? lastListItem.fullName : baseName;
};
